<template>
  <v-layout column>
    <v-layout row reverse class="mb-2"> </v-layout>

    <v-layout column justify-space-around>
      <v-flex v-if="!haveEmployees || apiCallPending">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
      <v-flex
        v-else
        class="py-4 mb-2"
        :key="location.id"
        v-for="location in orderedLocations"
      >
        <v-layout row justify-space-between class="mb-3">
          <v-flex>
            <h1 class="display-1">
              <LocationName :location="location" showColor />
            </h1>
          </v-flex>
          <v-flex class="text-xs-right">
            <div class="d-inline-block mr-2">
              <h2 class="all-caps">Category</h2>
            </div>
            <div class="d-inline-block">
              <ApiField
                :loading="gettingColors"
                fieldType="autocomplete"
                label="Category"
                :items="colorCategoriesAvailable"
                item-text="name"
                item-value="id"
                :object="location"
                paramName="worksite"
                storeAction="clientBusinesses/locationUpdate"
                fieldName="worksite_color_category_id"
                :storeFieldValue="location.worksiteColorCategoryId"
                clearable
              >
              </ApiField>
            </div>
          </v-flex>
        </v-layout>
        <TeamEditor :allEmployees="allEmployees" :location="location" />
        <v-divider class="mt-4 mb-4"></v-divider>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import collectionsApi from "@/api/collections";
import ApiField from "@/components/base/api-field.vue";
import TeamEditor from "@/components/hr/client-business-team-editor.vue";
import LocationName from "@/components/hr/location-name.vue";

export default {
  props: ["locations"],
  components: {
    ApiField,
    TeamEditor,
    LocationName
  },
  computed: {
    ...mapState("userAuth", ["user"]),

    exampleComputed: function() {
      return this.example;
    },
    orderedLocations: function() {
      return this.locations.slice().sort((a, b) => {
        let nameA = a.name.toLowerCase();
        let nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }
  },
  created() {
    this.setUp();
  },
  watch: {},
  data: function() {
    return {
      gettingColors: false,
      apiCallPending: false,
      haveEmployees: false,
      editingId: null,
      possibleManagers: [],
      newManager: null,
      mapDialog: null,
      allEmployees: [],
      colorCategoriesAvailable: []
    };
  },
  methods: {
    setUp() {
      this.apiCallPending = true;
      collectionsApi.getEmployees(
        employees => {
          this.allEmployees = employees;
          this.haveEmployees = true;
          this.apiCallPending = false;
        },
        error => {
          console.log(error);
          this.apiCallPending = false;
        }
      );

      this.gettingColors = true;
      collectionsApi.getWorksiteColorCategories(
        colors => {
          this.colorCategoriesAvailable = colors;
          this.gettingColors = false;
        },
        error => {
          console.log(error);
          this.gettingColors = false;
        }
      );
    }
  }
};
</script>

<style scoped></style>
